import { Helmet } from 'react-helmet';
import { Box, StyledEngineProvider, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import * as Sentry from '@sentry/capacitor';
import { ForcedTheme } from 'components/ForcedTheme';
import { PageLayout } from 'components/PageLayout';
import { WatchDutyThemeProvider } from 'theme';

const ErrorFallbackContent = (): JSX.Element => {
  const { t } = useTranslation();

  const handleAppReload = (): void => {
    Sentry.captureMessage('user-reloading-from-fatal-error-page', {
      level: 'fatal',
    });
    window.location.href = '/';
  };

  return (
    <ForcedTheme mode="light">
      <Box
        sx={{
          width: '100%',
          height: '100%',
          overflowY: 'auto',
          overflowX: 'hidden',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          bgcolor: 'brand.main',
        }}
      >
        <Typography variant="h2" align="center">
          {t('errorFallback.title')}
        </Typography>

        <Typography align="center">{t('errorFallback.description')}</Typography>

        <Button
          size="large"
          onClick={handleAppReload}
          sx={{ marginTop: 3 }}
          color="contrast"
        >
          {t('errorFallback.reload')}
        </Button>
      </Box>
    </ForcedTheme>
  );
};

const Content = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <StyledEngineProvider injectFirst>
      <WatchDutyThemeProvider>
        <Helmet>
          <title>{t('errorFallback.title')}</title>
        </Helmet>
        <ErrorFallbackContent />
      </WatchDutyThemeProvider>
    </StyledEngineProvider>
  );
};

export const ErrorFallback = (): JSX.Element => {
  return (
    <PageLayout data-cname="ErrorFallback" allowAppBanner={false}>
      <Content />
    </PageLayout>
  );
};
